import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class ClientInternalIdentificationIsInvalidError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.client.validation.internal-identification.invalid');
    }
}
